import axios from '../../../axios';

export const register = async (data, token = undefined) => {
  const recaptchaToken = await window.grecaptcha.execute(
    process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    {action: 'register'},
  );

  return await axios.post('register', data, {
    params: {
      ...(token ? {token: token} : {}),
      recaptchaToken,
    },
  });
};
